import { Dialog } from '@knack/asterisk-react';

import { usePageContext } from '@/context/PageContext';
import { PagePrint } from './PagePrint';

interface PageModalProps {
  onOpenChange: () => void;
  children: React.ReactNode;
}

export function PageModal({ onOpenChange, children }: PageModalProps) {
  const { activePage } = usePageContext();

  if (!activePage) {
    return null;
  }

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <Dialog.Content
        data-testid="page-modal"
        width="lg"
        aria-describedby={undefined}
        onPointerDownOutside={
          activePage.modalPreventBackgroundClickClose
            ? (event) => {
                event.preventDefault();
              }
            : undefined
        }
      >
        <Dialog.MainContent>
          <Dialog.Header>
            <Dialog.Title className="print:hidden">
              {activePage.name} {activePage.print && <PagePrint />}
            </Dialog.Title>
          </Dialog.Header>
          <div className="mt-4">{children}</div>
        </Dialog.MainContent>
      </Dialog.Content>
    </Dialog>
  );
}
